import { useParams } from 'react-router-dom';

import PatientProfileTab from '~/components/maud/patients/profile/tabs/PatientProfileTab';
import { useGetAssessmentsListQuery } from '~/store/services/assessments';

const ProfilePage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data: assessmentsList } = useGetAssessmentsListQuery(
    { patientId },
    { skip: !patientId },
  );

  return (
    <PatientProfileTab
      assessmentList={assessmentsList?.assessments ?? []}
      patientId={patientId}
    />
  );
};

export default ProfilePage;
